import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 13.414C13.1875 13.6016 13.4418 13.7069 13.707 13.707H14.293C14.5582 13.7069 14.8125 13.6016 15 13.414L19.707 8.707L22 11V5H16L18.293 7.293L14 11.586L11 8.586C10.8125 8.39845 10.5582 8.29306 10.293 8.293H9.70697C9.44177 8.29306 9.18746 8.39845 8.99997 8.586L2.29297 15.293L3.70697 16.707L9.99997 10.414L13 13.414Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TrendingUp"
);
